// @ts-expect-error jpgs are untyped modules
import DefaultImage from 'bender-url!../../assets/images/homepage-screenshot.jpg';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import CanonicalLink from 'marketplace-ui-common/components/elements/CanonicalLink';
import HrefLangLink from 'marketplace-ui-common/components/elements/HrefLangLink';
import MetaDescription from 'marketplace-ui-common/components/elements/MetaDescription';
import MetaOpenGraph from 'marketplace-ui-common/components/elements/MetaOpenGraph';
import MetaRobots from 'marketplace-ui-common/components/elements/MetaRobots';
import MetaTwitter from 'marketplace-ui-common/components/elements/MetaTwitter';
import DocumentHead from 'marketplace-ui-common/components/portals/DocumentHead';
import PrerenderHeader from 'marketplace-ui-common/components/prerender/PrerenderHeader';
import PrerenderReady from 'marketplace-ui-common/components/prerender/PrerenderReady';
import PrerenderStatusCode from 'marketplace-ui-common/components/prerender/PrerenderStatusCode';
import { PUBLIC_LANGUAGES } from 'marketplace-ui-common/constants/Languages';
import { useMemo } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { useGetScreenshotQuery } from '../../__generated__/chirp/com/hubspot/marketplace/urls/rpc/ScreenshotRpc.hooks';
import { getMarketplacePath } from '../utils/paths';
import { getFullPublicUrl } from '../utils/urls';
import { DocumentTitle } from './DocumentTitle';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StorefrontPageMetadata({
  canonicalPaths,
  loading = false,
  metaDescription: _metaDescription,
  prerenderHeaders,
  prerenderStatusCode,
  robotsDirective = ['follow'],
  title: _title
}) {
  const {
    pathname
  } = useLocation();
  const path = (canonicalPaths === null || canonicalPaths === void 0 ? void 0 : canonicalPaths.current) || pathname;
  const title = _title || unescapedText('marketplaceStorefront.documentHead.home.title');
  const metaDescription = _metaDescription || unescapedText('marketplaceStorefront.documentHead.home.metaDescription');
  const canonicalUrl = getFullPublicUrl(path);
  const renderedHrefLangLinks = useMemo(() => {
    return PUBLIC_LANGUAGES.map(lang => /*#__PURE__*/_jsx(HrefLangLink, {
      href: getFullPublicUrl(path, lang),
      lang: lang,
      "x-default": lang === 'en'
    }, `href-lang-${lang === 'en' ? 'default' : lang}`));
  }, [path]);
  const {
    data: screenshotData,
    loading: screenshotLoading
  } = useGetScreenshotQuery({
    variables: {
      language: getLang(),
      path: getMarketplacePath(path),
      siteKey: 'ecosystem'
    }
  });
  const imageMeta = useMemo(() => {
    if (screenshotLoading) {
      return null;
    }
    const imageUrl = (screenshotData === null || screenshotData === void 0 ? void 0 : screenshotData.imageUrl) || DefaultImage;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(MetaTwitter, {
        name: "image",
        content: imageUrl
      }), /*#__PURE__*/_jsx(MetaOpenGraph, {
        property: "image",
        content: imageUrl
      })]
    });
  }, [screenshotData === null || screenshotData === void 0 ? void 0 : screenshotData.imageUrl, screenshotLoading]);
  return /*#__PURE__*/_jsxs(DocumentHead, {
    children: [/*#__PURE__*/_jsx(DocumentTitle, {
      title: title
    }), /*#__PURE__*/_jsx(CanonicalLink, {
      href: canonicalUrl,
      rel: "canonical"
    }), (canonicalPaths === null || canonicalPaths === void 0 ? void 0 : canonicalPaths.next) && /*#__PURE__*/_jsx(CanonicalLink, {
      href: getFullPublicUrl(canonicalPaths.next),
      rel: "next"
    }), (canonicalPaths === null || canonicalPaths === void 0 ? void 0 : canonicalPaths.previous) && /*#__PURE__*/_jsx(CanonicalLink, {
      href: getFullPublicUrl(canonicalPaths.previous),
      rel: "prev"
    }), /*#__PURE__*/_jsx(MetaDescription, {
      content: metaDescription
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "title",
      content: title
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "description",
      content: metaDescription
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "type"
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "url",
      content: canonicalUrl
    }), /*#__PURE__*/_jsx(MetaRobots, {
      directive: robotsDirective
    }), /*#__PURE__*/_jsx(MetaTwitter, {
      name: "card"
    }), /*#__PURE__*/_jsx(MetaTwitter, {
      name: "site"
    }), renderedHrefLangLinks, imageMeta, /*#__PURE__*/_jsx(PrerenderReady, {
      ready: !loading && !screenshotLoading
    }), prerenderStatusCode !== undefined && /*#__PURE__*/_jsx(PrerenderStatusCode, {
      statusCode: prerenderStatusCode
    }), prerenderHeaders && Object.entries(prerenderHeaders).map(([header, value]) => /*#__PURE__*/_jsx(PrerenderHeader, {
      header: header,
      value: value
    }, header))]
  });
}